<template>
  <v-card>
    <v-form ref="form" :lazy-validation="true">
      <v-card-title>
        <h4>Ny person</h4>
      </v-card-title>
      <v-card-actions>
        <v-icon class="close" @click="$emit('close')">$sl-close</v-icon>
      </v-card-actions>

      <v-card-text class="pb-0 mb-0" v-if="error">
        <p class="mb-2 red--text">{{ error }}</p>
        <p class="mt-2">
          Vill du lägga till personen utan att hämta adress från SPAR så kan du välja 'Ange manuellt' knappen.
        </p>
      </v-card-text>

      <v-card-text>
        <v-text-field
          outlined
          name="personalNumber"
          label="Personnummer"
          v-model="personalNumber"
          :rules="[rules.required, rules.integer, rules.hasLength(12, personalNumber), rules.swePnr, ...userFilters]"
        />
      </v-card-text>

      <v-card-actions class="d-flex justify-end">
        <v-btn color="secondary" @click="$emit('close')"> <v-icon>$sl-cancel</v-icon>Avbryt </v-btn>

        <v-btn class="" color="secondary" @click="$emit('manual')"> <v-icon>$sl-edit</v-icon>Ange manuellt </v-btn>
        <v-btn @click="findPerson"> <v-icon>$sl-download</v-icon>Hämta adressuppgifter </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {mapGetters, mapActions} from 'vuex'
import {RulesMixin} from '@/components/mixins'

// @group Person
// PersonNewModal component
export default {
  name: 'PersonNewModal',

  mixins: [RulesMixin],

  data: () => ({
    personalNumber: null,
    error: null,
    person: {}
  }),

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'currentUserRole']),
    ...mapGetters('person', ['selectedPerson']),
    userFilters() {
      const userFilters = []
      if (this.currentUserRole === 'region') userFilters.push(this.rules.notMinor)
      return userFilters
    }
  },

  methods: {
    /**
     * @vuese
     * Used to get person information from  Spar
     * @arg The argument is an integer representing person personal number
     */
    findPerson() {
      this.error = null

      if (!this.$refs.form.validate()) {
        this.$events.fire('showError', 'Formuläret är inte korrekt ifyllt.')
        return
      }
      API.getSparPerson({data: {personalNumber: this.personalNumber}})
        .then(res => {
          //- Soft errors
          if (res.data.err) {
            this.error = res.data.msg
            return
          }
          // Fire person event ,after getting the result from  Spar
          // @arg The argument is object representing person data
          this.$emit('person', res.data)
        })
        .catch(error => {
          console.log(error)
          if (error && error.response && error.response.data) {
            this.error = error.response.data
            return
          }
        })
    }
  }
}
</script>

<style>
</style>